import IsValidResetToken from '../mutations/IsValidResetToken.gql'

export default function (variables) {
  return {
    mutation: IsValidResetToken,
    variables: variables,
  }
}
